import React from "react";
import TopNav from "../components/TopNav";
import BottomNav from "../components/BottomNav";
import Footer from "../components/footer/Footer";

function Policypage() {
  const styles = {
    page: {
      background: "#f7f8fb",
      minHeight: "100vh",
      width: "100%",
      overflowX: "hidden",
    },
    container: {
      maxWidth: 1100,
      margin: "0 auto",
      padding: "32px 18px 70px",
    },
    card: {
      background: "#ffffff",
      border: "1px solid #e8ebf2",
      borderRadius: 14,
      padding: "28px 26px",
      boxShadow: "0 6px 18px rgba(16, 24, 40, 0.06)",
    },
    titleRow: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      marginBottom: 18,
    },
    title: {
      fontSize: 34,
      lineHeight: 1.2,
      margin: 0,
      color: "#0f172a",
      letterSpacing: "-0.4px",
    },
    updated: {
      margin: 0,
      color: "#64748b",
      fontSize: 14,
    },
    lead: {
      padding: "14px 16px",
      borderRadius: 12,
      background: "#f1f5ff",
      border: "1px solid #dbe7ff",
      color: "#1e3a8a",
      margin: "14px 0 22px",
      lineHeight: 1.8,
      fontSize: 15.5,
    },
    section: {
      marginTop: 22,
      paddingTop: 18,
      borderTop: "1px solid #eef1f6",
    },
    h3: {
      fontSize: 18,
      margin: "0 0 10px",
      color: "#111827",
    },
    p: {
      margin: "0 0 12px",
      color: "#334155",
      lineHeight: 1.9,
      fontSize: 15.5,
    },
    ul: {
      margin: "8px 0 12px 18px",
      padding: 0,
      color: "#334155",
      lineHeight: 1.9,
      fontSize: 15.5,
    },
    contactBox: {
      background: "#f8fafc",
      border: "1px solid #e2e8f0",
      borderRadius: 12,
      padding: "14px 16px",
      marginTop: 10,
    },
    link: {
      color: "#2563eb",
      textDecoration: "none",
      fontWeight: 600,
    },
  };

  return (
    <div className="legal-page" style={styles.page}>
      {/* Page-only CSS overrides (hide sidebar + remove left gap) */}
      <style>{`
        .sidebar, .Sidebar, .side-bar, .left-sidebar, .app-sidebar, .sidebar-wrapper,
        .sidebarLayout, .sidebar-layout, .sidebar-container, .drawer, .MuiDrawer-root {
          display: none !important;
          width: 0 !important;
        }

        .content, .page-content, .main-content, .layout-content, .dashboard-content,
        .with-sidebar, .has-sidebar {
          margin-left: 0 !important;
          padding-left: 0 !important;
        }

        #root, body, html { margin-left: 0 !important; }
        .legal-page * { box-sizing: border-box; }
      `}</style>

      

      <main style={styles.container}>
        <section style={styles.card}>
          <div style={styles.titleRow}>
            <h1 style={styles.title}>Privacy Policy of Makkaan.com</h1>
            <p style={styles.updated}>
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div style={styles.lead}>
            At Makkaan.com, we value the privacy of our users and are committed to
            protecting their personal information. This Privacy Policy outlines
            how we collect, use, disclose, and protect the data we collect from
            users of our website and any related services. By accessing or using
            our Website, you agree to the terms and practices described in this
            policy.
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Information We Collect</h3>
            <ul style={styles.ul}>
              <li>
                <strong>Personal Information:</strong> This includes, but is not
                limited to, your name, email address, phone number, postal address,
                and other information provided voluntarily during registration,
                inquiries, or while using our services.
              </li>
              <li>
                <strong>Non-Personal Information:</strong> We may automatically
                collect certain non-personal information about your use of our
                Website, such as your IP address, browser type, device information,
                and cookies to enhance your browsing experience and improve our
                services.
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>How We Use Information</h3>
            <p style={styles.p}>We use the collected information for the following purposes:</p>
            <ul style={styles.ul}>
              <li>
                <strong>Providing Services:</strong> To facilitate your access to and
                use of our Website and to provide the services you request.
              </li>
              <li>
                <strong>Communication:</strong> To respond to your inquiries, provide
                customer support, and send you important updates and notifications
                related to our services.
              </li>
              <li>
                <strong>Personalization:</strong> To personalize and improve your
                experience on our Website, including providing relevant content and
                recommendations.
              </li>
              <li>
                <strong>Marketing:</strong> To send you promotional materials and
                offers, which you can opt out of at any time.
              </li>
              <li>
                <strong>Analytics:</strong> To analyze user behavior, preferences,
                and trends to enhance our services and user experience.
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Data Sharing with Third Parties</h3>
            <p style={styles.p}>
              We may share your information with third parties under the following circumstances:
            </p>
            <ul style={styles.ul}>
              <li>
                <strong>Service Providers:</strong> We may engage trusted third-party
                service providers to assist us in providing the Website and related
                services. These providers have access to your information only to
                perform specific tasks on our behalf and are obligated not to disclose
                or use it for any other purpose.
              </li>
              <li>
                <strong>Legal Compliance:</strong> We may share your information if
                required by law or in response to valid legal requests, such as a
                court order or government inquiry.
              </li>
              <li>
                <strong>Business Transfers:</strong> In the event of a merger,
                acquisition, or sale of all or a portion of our assets, your
                information may be transferred to the acquiring entity.
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Third-Party Services</h3>
            <p style={styles.p}>
              We engage third-party services to display advertisements on our website,
              and these third parties may employ cookies or other methods to assess
              the impact of their ads. Additionally, our website may contain links to
              unrelated external websites and contact forms associated with other
              unrelated parties that might gather personal information.
            </p>
            <p style={styles.p}>
              Please note that our privacy policy does not apply to these third parties
              or external websites, and we advise users to review their respective
              privacy policies before providing any personal details to these entities.
            </p>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Safety and Security</h3>
            <p style={styles.p}>
              We process and store personal information in our databases, implementing
              reasonable measures to safeguard and protect the data from unauthorized
              access or disclosure. Despite our best efforts to ensure security, we
              cannot guarantee absolute protection against misuse, accidental disclosure,
              or unauthorized actions by third parties. Please be aware that the
              information you provide may be stored or processed outside Pakistan.
            </p>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Contact Us</h3>
            <p style={styles.p}>
              If you have any questions or concerns about this Privacy Policy or our
              data practices, please contact us at:
            </p>
            <div style={styles.contactBox}>
              <p style={{ ...styles.p, marginBottom: 8 }}>
                <strong>UAN:</strong> +923311111049
              </p>
              <p style={{ ...styles.p, marginBottom: 0 }}>
                <strong>Email:</strong>{" "}
                <a style={styles.link} href="mailto:info@makkaan.com">
                  info@makkaan.com
                </a>
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <h3 style={styles.h3}>Changes to Our Privacy Policy</h3>
            <p style={styles.p}>
              Any modifications or revisions to our privacy policy in the future will
              be published on this page, and if necessary, we will inform you via email.
              We encourage you to visit this page regularly to stay informed about any
              updates or adjustments made to our privacy policy.
            </p>
            <p style={styles.p}>
              By using Makkaan.com, you consent to the collection and use of your
              information as described in this Privacy Policy.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Policypage;
